import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { XcHelpPart, XcHelpPresetType } from '@gspwidget/util';
import { XcHelpService } from '../help.service';

@Component({
  selector: 'xc-help-input',
  templateUrl: './help-input.component.html',
  styleUrls: ['./help-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
/** xcPerset å xcParts + xcTitle ä»»éå¶ä¸å¿å¡«ã */
export class HelpInputComponent<T> implements OnInit {
  @Input() xcPreset: XcHelpPresetType
  @Input() xcParts: XcHelpPart[]
  @Input() xcTitle: string
  @Input() xcLabel: string
  @Input()
  // @Input() value: string
  @Output() xcValueChange = new EventEmitter<T>()

  constructor (
    public xcHelp2: XcHelpService,
  ) { }

  ngOnInit () {
  }

  handleClick () {
    if (this.xcParts) {
      this.xcHelp2.create({
        xcParts: this.xcParts,
        xcTitle: this.xcTitle,
        xcOnOk: (result: T) => {
          this.xcValueChange.emit(result)
        }
      })
    }
    if (this.xcPreset) {
      this.xcHelp2.createPreset({
        xcPreset: this.xcPreset,
        xcOnOk: (result: T) => {
          this.xcValueChange.emit(result)
        }
      })
    }
  }

}
